module.exports = __webpack_public_path__ + "static/media/ticket-support.11022f20.png";